// Define constants for button click events
export const ButtonClickEvents = {
  //authlayout button events
  LOGO_CLICK: "logo_click",
  SCHOOL_ADMIN_TEXT_CLICK: "school_admin_text_click",
  TEACHER_TEXT_CLICK: "teacher_text_click",
  PTA_TEXT_CLICK: "pta_text_click",
  JOIN_CLASSROOM_AS_STUDENT_CLICK: "join_classroom_as_student_click",
  LOGIN_BUTTON_CLICK: "login_button_click",
  FORGOT_PASSWORD_TEXT_CLICK: "forgot_password_text_click",
  FORGOT_PASSWORD_OK_BUTTON_CLICK: "forgot_password_ok_button_click",
  STUDENT_SIGNUP_BUTTON_CLICK: "student_signup_button_click",
  BACK_TO_LOGIN_BUTTON_CLICK: "back_to_login_button_click",

  //Admin login - teacher tab
  TEACHER_CREATE_SAVE_BUTTON_CLICK: "teacher_create_save_button_click",
  TEACHER_CLEAR_BUTTON_CLICK: "teacher_clear_button_click",
  TEACHER_DELETE_BUTTON_CLICK: "teacher_delete_button_click",

  //Admin login - student tab
  STUDENT_SHARE_BUTTON_CLICK: "student_share_button_click",
  STUDENT_SHARE_DISCARD_BUTTON_CLICK: "student_share_discard_button_click",
  STUDENT_SHARE_MOVE_BUTTON_CLICK: "student_share_move_button_click",
  STUDENT_PROFILE_SAVE_BUTTON_CLICK: "student_profile_save_button_click",
  STUDENT_PROFILE_DELETE_BUTTON_CLICK: "student_profile_delete_button_click",

  //Admin login - classroom tab
  CREATE_CLASS_SAVE_BUTTON_CLICK: "create_class_save_button_click",
  CREATE_CLASS_CLEAR_BUTTON_CLICK: "create_class_clear_button_click",

  //Admin login - Announcement tab
  CREATE_ANNOUNCEMENT_SAVE_BUTTON_CLICK: "create_announcement_save_button_click",
  CREATE_ANNOUNCEMENT_CLEAR_BUTTON_CLICK: "create_announcement_clear_button_click",
  ANNOUNCEMENT_EDIT_BUTTON_CLICK: "announcement_edit_button_click",
  ANNOUNCEMENT_DELETE_BUTTON_CLICK: "announcement_delete_button_click",
  ANNOUNCEMENT_SHARE_TO_ALL_BUTTON_CLICK: "announcement_share_to_all_button_click",
  ANNOUNCEMENT_UNDO_SHARE_BUTTON_CLICK: "announcement_undo_share_button_click",

  //Admin upload 
  ADMIN_UPLOAD_CLICK: "admin_upload_click",

  //File upload component
  FILE_UPLOAD_BUTTON_CLICK: "file_upload_button_click",

  //Workshop
  SAVE_MEETING: "save_meeting_button_click",
  CLEAR_MEETING: "clear_meeting_button_click",
  SCHEDULE_MEETING: "schedule_meeting_button_click",
    
  //Meetings
  JOIN_MEETING: "join_meeting_button_click",
  START_MEETING: "start_meeting_button_click",

  //School profile
  SCHOOL_PROFILE_SAVE: "school_profile_save_button_click",

  //Calendar
  CALENDAR_SAVE: "calendar_save_button_click",
  CALENDAR_CLOSE: "calendar_close_button_click",
  CALENDAR_CLEAR: "calendar_clear_button_click",

  // PTA
  PTA_BOX_CLICK: "pta_box_click",
  PTA_SCHEDULE_MEETING_CLEAR_BUTTON_CLICK: "pta_schedule_meeting_clear_button_click",
  PTA_SCHEDULE_MEETING_SAVE_BUTTON_CLICK: "pta_schedule_meeting_save_button_click",

  //Quiz

  QUIZ_CREATE_BUTTON_CLICK: "quiz_create_button_click",
  QUIZ_SUBMIT: "quiz_submit_button_click",

  //Liveclass

  LIVECLASS_SCHEDULE_SAVE_BUTTON_CLICK: "liveclass_schedule_save_button_click",
  LIVECLASS_SCHEDULE_CLEAR_BUTTON_CLICK: "liveclass_schedule_clear_button_click",

  UPLOAD_MATERIALS: "upload_materials_popup_click",
  UPLOAD_MATERIALS_SUBMIT: "upload_materials_submit_click",

  LOGOUT_BUTTON_CLICK : "logout_button_click",
  CLEAR_MEETING_FORM: "clear_meeting_form",

  FAQ_TEXT_CLICK: "faq_text_click",
  LEGAL_TEXT_CLICK: "legal_text_click",
  SUPPORT_TEXT_CLICK: "support_text_click",

  FACEBOOK_ICON_CLICK: "facebook_icon_click",
  TWITTER_ICON_CLICK: "twitter_icon_click",
  YOUTUBE_ICON_CLICK: "youtube_icon_click",
  TIKTOK_ICON_CLICK: "tiktok_icon_click",
  INSTAGRAM_ICON_CLICK: "instagram_icon_click",
  lINKEDIN_ICON_CLICK: "linkedin_icon_click",
  JITSI_LEAVE_MEETING_BUTTON_CLICK: "jitsi_leave_meeting_button_click",
  JITSI_END_MEETING_BUTTON_CLICK: "jitsi_end_meeting_button_click",
} as const;

export type ButtonClickEventType =
  typeof ButtonClickEvents[keyof typeof ButtonClickEvents];

// Common events
export const CommonEvents = {
  PAGE_VIEW: "page_view",
} as const;

const PAGE_EVENT = (name: string) => `${name}_page_view`;

export const PageViewEvents: Record<string, string> = {
  "/": "landing_page_view",
  "/admin-login": "admin_login_page_view",
  "/teacher-login": "teacher_login_page_view",
  "/teacher-select-class": "teacher_select_class_page_view",
  "/pta-signup": "pta_signup_page_view",
  "/pta-login": "pta_login_page_view",
  "/pta-verifyCode": "pta_verify_code_page_view",
  "/student-signup": "student_signup_page_view",
  "/student-login": "student_login_page_view",
  "/student-verifyCode": "student_verify_code_page_view",
  "/student-forgot-password": PAGE_EVENT("student_forgot_password"),
  "/faq": "faq_page_view",
  "/legal": "legal_page_view",
  "/support": "support_page_view",

  // ADMIN ROUTES
  "/admin-dashboard": "admin_dashboard_page_view",
  "/admin-school": "admin_profile_page_view",
  "/admin-workshop": "admin_workshop_page_view",
  "/admin-calendar": "admin_calendar_page_view",
  "/admin-notification": "admin_notification_page_view",
  "/admin-settings": "admin_settings_page_view",
  "/admin-materials-upload": "admin_materials_upload_page_view",
  "/admin-materials-upload/materials": "admin_materials_list_page_view",
  "/admin-materials-upload/bulk-upload": "admin_bulk_upload_page_view",
  "/admin-help": "admin_help_page_view",
  "/admin-help/admin-terms-and-privacy-policy": "admin_terms_privacy_page_view",
  "/admin-help/help-center": "admin_help_center_page_view",
  "/admin-system-message": "admin_system_message_page_view",
  "/admin-pta": "admin_pta_page_view",
  "/admin-pta/meetings": "admin_pta_meetings_page_view",

  "/admin-materials-upload/materials/ebooks": "admin_materials_ebooks_page_view",
  "/admin-materials-upload/materials/images": "admin_materials_images_page_view",
  "/admin-materials-upload/materials/videos": "admin_materials_videos_page_view",
  "/admin-materials-upload/materials/podcast": "admin_materials_podcast_page_view",
  "/admin-materials-upload/materials/ebooks/materials": "admin_ebook_materials_list_page_view",
  "/admin-materials-upload/materials/images/materials": "admin_image_materials_list_page_view",
  "/admin-materials-upload/materials/videos/materials": "admin_video_materials_list_page_view",
  "/admin-materials-upload/materials/podcast/materials": "admin_podcast_materials_list_page_view",
  "/admin-materials-upload/materials/ebooks/materials/teaching-materials": "admin_teaching_materials_page_view",
  "/admin-materials-upload/materials/ebooks/materials/examination-guide": "admin_exam_guide_page_view",
  "/admin-materials-upload/materials/ebooks/materials/question-bank": "admin_question_bank_page_view",

  // TEACHER ROUTES
  "/teacher-classroom": "teacher_classroom_page_view",
  "/teacher-classroom/ebooks": "teacher_ebooks_page_view",
  "/teacher-classroom/images": "teacher_images_page_view",
  "/teacher-classroom/podcast": "teacher_podcast_page_view",
  "/teacher-classroom/podcast/materials": "teacher_podcast_materials_page_view",
  "/teacher-classroom/videos": "teacher_videos_page_view",
  "/teacher-classroom/ebooks/materials": "teacher_ebook_materials_page_view",
  "/teacher-classroom/images/materials": "teacher_image_materials_page_view",
  "/teacher-classroom/videos/materials": "teacher_video_materials_page_view",
  "/teacher-calendar": "teacher_calendar_page_view",
  "/teacher-announcement": "teacher_announcement_page_view",
  "/teacher-classroom/ebooks/materials/teaching-materials": "teacher_teaching_materials_page_view",
  "/teacher-classroom/ebooks/materials/examination-guide": "teacher_exam_guide_page_view",
  "/teacher-classroom/ebooks/materials/question-bank": "teacher_question_bank_page_view",
  "/teacher-classroom/liveclass": "teacher_live_class_page_view",
  "/teacher-classroom/quiz": "teacher_quiz_page_view",
  "/teacher-classroom/assignments": "teacher_assignments_page_view",
  "/teacher-classroom/quiz/test": "teacher_quiz_test_page_view",
  "/teacher-classroom/chats": "teacher_chats_page_view",
  "/teacher-workshop": "teacher_workshop_page_view",
  "/teacher-pta": "teacher_pta_page_view",
  "/teacher-settings": "teacher_settings_page_view",
  "/teacher-help": "teacher_help_page_view",
  "/teacher-help/teacher-terms-and-privacy-policy": "teacher_terms_privacy_page_view",
  "/teacher-help/help-center": "teacher_help_center_page_view",
  "/teacher-settings/profile": "teacher_profile_page_view",
  "/school-profile": "school_profile_page_view",
  "/teacher-InAppdownloads": "teacher_inapp_downloads_page_view",
  "/teacher-downloads": "teacher_downloads_page_view",

  // STUDENT ROUTES
  "/underConstruction": "under_construction_page_view",
  "/student-classroom": "student_classroom_page_view",
  "/student-settings": "student_settings_page_view",
  "/student-settings/profile": "student_profile_page_view",
  "/student-classroom/ebooks": "student_ebooks_page_view",
  "/student-classroom/images": "student_images_page_view",
  "/student-classroom/videos": "student_videos_page_view",
  "/student-classroom/ebooks/materials": "student_ebook_materials_page_view",
  "/student-classroom/images/materials": "student_image_materials_page_view",
  "/student-classroom/videos/materials": "student_video_materials_page_view",
  "/student-classroom/ebooks/materials/learning-materials": "student_learning_materials_page_view",
  "/student-classroom/ebooks/materials/examination-guide": "student_exam_guide_page_view",
  "/student-classroom/ebooks/materials/question-bank": "student_question_bank_page_view",
  "/student-classroom/question-bank/test": "student_test_page_view",
  "/student-classroom/question-bank/view": "student_question_view_page_view",
  "/student-classroom/quiz": "student_quiz_page_view",
  "/student-classroom/quiz/test": "student_quiz_test_page_view",
  "/student-classroom/quiz/view": "student_quiz_view_page_view",
  "/student-classroom/chats": "student_chats_page_view",
  "/student-classroom/liveclass": "student_liveclass_page_view",
  "/student-classroom/assignments": "student_assignments_page_view",
  "/student-classroom/podcast": "student_podcast_page_view",
  "/student-classroom/podcast/materials": "student_podcast_materials_page_view",
  "/student-calendar": "student_calendar_page_view",
  "/student-announcement": "student_announcement_page_view",
  "/student-help": "student_help_page_view",
  "/student-help/student-terms-and-privacy-policy": "student_terms_privacy_page_view",
  "/student-help/help-center": "student_help_center_page_view",
  "/student-downloads": "student_downloads_page_view",
  "/student-InAppdownloads": "student_inapp_downloads_page_view",

  // PTA ROUTES
  "/pta-meetings": "pta_meetings_page_view",
  "/pta/meeting": "pta_meeting_page_view",

  // MEETINGS
  "/teacher-classroom/liveclass/meeting": "teacher_liveclass_meeting_page_view",
  "/teacher-workshop/meeting": "teacher_workshop_meeting_page_view",
  "/teacher/pta/meeting": "teacher_pta_meeting_page_view",
  "/admin-workshop/meeting": "admin_workshop_meeting_page_view",
  "/admin/pta/meeting": "admin_pta_meeting_page_view",
  "/student-classroom/liveclass/meeting": "student_liveclass_meeting_page_view",
};

// ----------------------------
// ROUTE NAME MAPPING
// ----------------------------
export const RouteNames: Record<string, string> = Object.fromEntries(
  Object.entries(PageViewEvents).map(([route, event]) => [
    route,
    event.replace(/_/g, ' ').replace('page view', 'Page').replace(/\b\w/g, c => c.toUpperCase()),
  ])
);

// ----------------------------
// PAGE CONSTANTS
// ----------------------------
export const Pages = {
  LANDING_PAGE: "Landing Page",
  ADMIN_DASHBOARD_PAGE: "Admin Dashboard Page",
  TEACHER_CLASSROOM_PAGE: "Teacher Classroom Page",
  STUDENT_CLASSROOM_PAGE: "Student Classroom Page",
  PTA_MEETINGS_PAGE: "PTA Meetings Page",
  MEETING_PAGE: "Meeting Page",
  WORKSHOP_PAGE: "Workshop Page",
  SETTINGS_PAGE: "Settings Page",
  HELP_PAGE: "Help Page",
  ADMIN_UPLOAD_PAGE: "Admin Upload Page",
};